import type { FlowGraph, InteractionLayout } from './types';

export function resolveInteractionLayout(flow: FlowGraph): InteractionLayout {
  if (flow.settings.interactionLayout === 'side-panel' || flow.settings.interactionLayout === 'bottom-sheet') {
    return flow.settings.interactionLayout;
  }
  const legacy = flow.nodes.find((node) => node.content.interactionLayout === 'side-panel' || node.content.interactionLayout === 'bottom-sheet')?.content.interactionLayout;
  return legacy === 'side-panel' ? 'side-panel' : 'bottom-sheet';
}
